<template>
  <div class="scan-page">
    <div class="header-bar">
      <h2>{{ event.name }} - Escanear boleto</h2>
      <CButton color="secondary" @click="goBack">
        ← Volver al evento
      </CButton>
    </div>

    <div class="camera-box">
      <p>Activa la cámara para escanear el código QR</p>
      <div id="qr-reader"></div>
    </div>

    <div v-if="scanStatus" class="scan-result" :class="scanStatus">
      <h3 v-if="scanStatus === 'success'">✅ Acceso válido</h3>
      <h3 v-else-if="scanStatus === 'error'">❌ Acceso denegado</h3>
      <h3 v-else-if="scanStatus === 'invalid'">⚠️ Código inválido</h3>
      <p>{{ message }}</p>
      <CButton @click="startScanner" color="dark">
        Volver a escanear
      </CButton>
    </div>
  </div>
</template>


<script>
import { Html5Qrcode } from "html5-qrcode";
import ws from '@/services/events_guests';
import ws_event from '@/services/events';
import store from '@/store';

export default {
  name: 'ScanTickets',

  data() {
    return {
      scanning: false,
      scanStatus: null, // 'success' | 'error' | null
      message: '',
      event: {
        name: ''
      }
    }
  },

  async mounted() {
    this.loading();
    this.event_id = this.$route.params.id;
    await this.getEvent();
    this.qrScanner = new Html5Qrcode("qr-reader");

    this.qrScanner.start(
      { facingMode: "environment" },
      {
        fps: 10,
        qrbox: 250,
      },
      (decodedText) => {
        this.onScanSuccess(decodedText);
        this.qrScanner.stop();
      }
    );
    this.loaded();
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'Invitados', params: { id: this.event.id } });
    },
    async getEvent() {
      let response_event = await ws_event.show(this.event_id);
      if (response_event.type == "success") {
        this.event = response_event.data;
      }
    },  
    onScanSuccess(scannedText) {
      this.loading();
      const prefix = 'confirmame://ticket/';

      if (!scannedText.startsWith(prefix)) {
        this.scanStatus = 'invalid';
        this.message = 'Código QR inválido.';
        return;
      }

      const token = scannedText.replace(prefix, '');

      const payload = {
        event_id: this.event_id,
        token: token
      };

      ws.scanTicket(payload)
        .then(response => {
          if(response.type == "success"){
            this.scanStatus = 'success';
            this.message = response.message || 'Boleto válido.';
          } else if(response.type == "error"){
            this.scanStatus = 'error';
            this.message = response.message || 'Boleto inválido o ya utilizado.';
          } else {
            this.scanStatus = 'invalid';
            this.message = response.message || 'Código inválido.';
          }          
        }).catch(error => {
          this.scanStatus = 'error';
          this.message = 'Error al procesar el boleto.';
        });
      this.loaded();
    },
    startScanner() {
      this.scanStatus = null;
      this.message = null;
      this.scanning = true;

      if (!this.qrScanner) {
        this.qrScanner = new Html5Qrcode("qr-reader");
      }

      this.qrScanner.start(
        { facingMode: "environment" },
        {
          fps: 10,
          qrbox: 250,
        },
        (decodedText) => {
          this.onScanSuccess(decodedText);
          this.qrScanner.stop();
          this.scanning = false;
        }
      );
    },
    loading() {
      store.commit('loading');
    },
    loaded() {
      store.commit('loaded');
    }
  }
}
</script>

<style scoped>
.scan-result.success {
  color: green;
}

.scan-result.error {
  color: red;
}

.scan-result.invalid {
  color: orange;
}

.scan-page {
  padding: 20px;
}

.camera-box {
  margin-top: 20px;
  padding: 20px;
  border: 2px dashed #ccc;
  text-align: center;
}
.header-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
@media (max-width: 767px) {
  .header-bar {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .header-bar .btn {
    align-self: flex-start;
    padding: 4px 10px;
    font-size: 0.85rem;
  }
}

</style>
